import { OnInit, OnChanges } from '@angular/core/src/metadata/lifecycle_hooks';
import { Component, Input, ElementRef, Output, EventEmitter } from '@angular/core';
import { TravelService, SeatAllocation, SeatStatus } from '../../services/travel.service';
import { StopItem, ReferenceDataService } from '../../services/reference-data.service';
import * as moment from 'moment';
import { ActionUpdaterService } from '../../services/action-updater.service';
import { DeviceService } from '../../services/device.service';

@Component({
    selector: 'gaweb-seat-allocations',
    templateUrl: `./seat-allocations.component.html`
})
export class SeatAllocationsComponent implements OnInit {
    @Input() index: number;
    @Input() readOnly: any;
    @Input() service: string;
    @Input() serviceDate: Date;
    @Input() passengerDepartureDate: any;
    @Input() bookingNumber: string;
    @Input() startStop: string;
    @Input() endStop: string;
    @Input() collapsable: any;
    @Input() passengerTotal: number;
    @Input() bookingGuid: string;
    @Input() travelGuid: string;
    @Input() sectorGuid: string;
    @Output() editModeActive = new EventEmitter<boolean>();
    @Output() newSeats = new EventEmitter<Array<SeatAllocation>>();

    results: Array<Array<SeatAllocation>> = null;
    totalRows = [0];
    totalSeatLetters = [0];
    serviceDeparted = 'false';
    noSeatsAvailable = false;
    driverAllocatesSeats = false;

    public allSeatsSelected = true;

    public seatChanges: Array<SeatAllocation> = new Array<SeatAllocation>();
    public currentSeats: Array<SeatAllocation> = new Array<SeatAllocation>();
    public startStopDetails: StopItem;
    public endStopDetails: StopItem;
    public collapsed = false;

    public editMode = false;    
    private updatingCount = 0;

    constructor(private travelService: TravelService,
                private referenceDataService: ReferenceDataService,
                private componentElement: ElementRef,
                private actionUpdaterService: ActionUpdaterService,
                private deviceService: DeviceService) {}
    async ngOnInit(): Promise<void> {
        if (this.readOnly == null) {
            this.readOnly = true;
        }

        this.passengerDepartureDate = moment(this.passengerDepartureDate, 'DD/MM/YYYY hh:mm:ss A');
        if (this.passengerDepartureDate.isBefore()) {
            this.readOnly = 'true';
            this.serviceDeparted = 'true';
        }
        else {
            if(this.readOnly == 'false') {
                this.setEditMode(true);
            }
        }

        this.travelService
            .getSeating(this.service, this.serviceDate, this.startStop, this.endStop, this.bookingGuid, this.travelGuid)
            .subscribe(data => {
                this.results = data;
                this.getSeats(this.results);
            }, err =>  this.actionUpdaterService.announceError(err));
            await this.travelService.getStops().then((stops) => {
                    stops.forEach(stop => {
                    if (stop.Code === this.startStop) {
                        this.startStopDetails = stop;
                    }

                    if (stop.Code === this.endStop) {
                        this.endStopDetails = stop;
                    }
            });
    });
    }

    collapse() {
        if (this.collapsable !== 'true') {
            return false;
        }
        this.collapsed = !this.collapsed;
        this.updateCss();
    }

    getSeats(data) {
        let hasAvailableSeat = false;
        data.forEach((seat: SeatAllocation) => {
            if (seat.Row > this.totalRows.length) {
                this.totalRows = Array(seat.Row)
                    .fill(1, 0, seat.Row)
                    .map((x, i) => i + 1);
            }

            if (
                this.seatLetterToIndex(seat.Seat) > this.totalSeatLetters.length
            ) {
                const count = this.seatLetterToIndex(seat.Seat);
                this.totalSeatLetters = Array(count)
                    .fill(1, 0, count)
                    .map((x, i) => i + 1);
            }

            if (seat.Status === SeatStatus.Selected) {
                this.currentSeats.push(seat);
            }
            if (seat.Status == SeatStatus.Available) {
                hasAvailableSeat = true;
            }
        });
        this.results = this.chunkArray(
            data as Array<any>,
            this.totalSeatLetters.length - 1
        );
        if (this.currentSeats.length > this.passengerTotal) {
            this.passengerTotal = this.currentSeats.length;
        }
        this.noSeatsAvailable = !hasAvailableSeat;
        this.driverAllocatesSeats = this.noSeatsAvailable && (this.currentSeats == null || this.currentSeats.length == 0);
        this.newSeats.emit(data);
    }

    applyChanges() {
        this.updatingCount = this.updatingCount + 1;
        this.travelService.updateSeating(this.bookingGuid, this.sectorGuid, this.seatChanges).subscribe(data => {            
            this.currentSeats = new Array<SeatAllocation>();
            this.seatChanges = new Array<SeatAllocation>();
            this.getSeats(data);
            this.actionUpdaterService.announceSuccess('Seats have been successfully changed.');
            this.updatingCount = this.updatingCount - 1;            
        }, err =>  
        {
            this.updatingCount = this.updatingCount - 1;
            this.actionUpdaterService.announceError(err)
        });
        //this.setEditMode(false);
    }

    resetChanges() {
        this.travelService
            .getSeating(this.service, this.serviceDate, this.startStop, this.endStop, this.bookingGuid, this.travelGuid)
            .subscribe(data => {
                this.results = data;
                this.currentSeats = new Array<SeatAllocation>();
                this.seatChanges = new Array<SeatAllocation>();
                this.getSeats(this.results);
            });
        //this.setEditMode(false);
    }

    updateSeats(event: Event, rIndex, sIndex, seatClicked) {

        let counterB = 0;
        $('.seat-input input[type="checkbox"]:checked').each((index, element) => {
            if ($(element).attr('id').split('-')[0] === this.bookingNumber.toString()
            && $(element).attr('id').split('-')[1] === this.service.toString()
            && $(element).attr('id').split('-')[4] === this.index.toString()) {
            if (counterB > total) {
                total = counterB;
            }
            counterB++;
        }
        });
        if(this.passengerTotal == counterB) {
            this.allSeatsSelected = true;
        } else {
            this.allSeatsSelected = false
        }

        let total = 0;
        const seat = this.results[rIndex][sIndex];
        let counter = 0;
        $('.seat-input input[type="checkbox"]:checked').each((index, element) => {
              if ($(element).attr('id').split('-')[0] === this.bookingNumber.toString()
                && $(element).attr('id').split('-')[1] === this.service.toString()
                && $(element).attr('id').split('-')[4] === this.index.toString()) {
                if (counter > total) {
                    total = counter;
                }
                counter++;
            if ($(element).attr('checked') === 'true') {
                // alert('checked: ' + $(element).attr('id'));
            }
        }
        });
        if (total >= this.passengerTotal || seat.Status === 2) {
            event.preventDefault();
        } else {
            this.seatChanges = new Array<SeatAllocation>();
            let counterB = 0;
            $('.seat-input input[type="checkbox"]:checked').each((index, element) => {
                if ($(element).attr('id').split('-')[0] === this.bookingNumber.toString()
                && $(element).attr('id').split('-')[1] === this.service.toString()
                && $(element).attr('id').split('-')[4] === this.index.toString()) {
                if (counterB > total) {
                    total = counterB;
                }
                counterB++;

                const seatIndex = parseInt($(element).attr('id').split('-')[2], 10);
                const rowIndex = parseInt($(element).attr('id').split('-')[3], 10);
                this.seatChanges.push( new SeatAllocation(this.indexToSeatLetter(seatIndex + 1).toString(), rowIndex + 1, SeatStatus.Selected));
            }
            });
            if(this.passengerTotal == counterB) {
                this.applyChanges();
            }
        }
    }

    chunkArray(myArray, chunk_size) {
        myArray = myArray as Array<any>;
        const arrayLength = myArray.length;
        const tempArray = [];
        for (let index = 0; index < arrayLength; index += chunk_size + 1) {
            const myChunk = myArray.slice(index, index + chunk_size + 1);
            tempArray.push(myChunk);
        }

        return tempArray;
    }

    isUpdating()
    {
        return this.updatingCount > 0;
    }

    setEditMode(val: boolean) {
        this.editMode = val;
        this.editModeActive.emit(val);
        this.updateCss();
    }

    private seatLetterToIndex(seatLetter) {
        switch (seatLetter) {
            case 'A':
                return 1;
            case 'B':
                return 2;
            case 'C':
                return 3;
            case 'D':
                return 4;
            case 'E':
                return 5;
            case 'F':
                return 6;
            case 'G':
                return 7;
            case 'H':
                return 8;
            default:
                return 0;
        }
    }

    private indexToSeatLetter(index) {
        switch (index) {
            case 1:
                return 'A';
            case 2:
                return 'B';
            case 3:
                return 'C';
            case 4:
                return 'D';
            case 5:
                return 'E';
            case 6:
                return 'F';
            case 7:
                return 'G';
            case 8:
                return 'H';
            default:
                return 0;
        }
    }

    private updateCss() {
        if (this.collapsed) {
            if (!$(this.componentElement.nativeElement).hasClass('collapsed')) {
                $(this.componentElement.nativeElement).addClass('collapsed');
            }
        } else {
            if ($(this.componentElement.nativeElement).hasClass('collapsed')) {
             $(this.componentElement.nativeElement).removeClass('collapsed');
            }
        }

        /*if (this.editMode) {
            if (!$(this.componentElement.nativeElement).hasClass('edit-mode')) {
                $(this.componentElement.nativeElement).addClass('edit-mode');
            }
        } else {
            if ($(this.componentElement.nativeElement).hasClass('edit-mode')) {
             $(this.componentElement.nativeElement).removeClass('edit-mode');
            }
        }*/
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/seat-allocations/seat-allocations.component.ts